// Preserve the existing Leaflet TileLayer defaults (0–18) used by our OSM
// basemap. The map needs these at construction, before passive tile effects:
// markercluster's onAdd rejects an infinite map maximum.
export const MIN_MAP_ZOOM = 0;
export const MAX_MAP_ZOOM = 18;

export const clampMapZoom = (zoom) =>
  Number.isFinite(zoom)
    ? Math.min(MAX_MAP_ZOOM, Math.max(MIN_MAP_ZOOM, zoom))
    : 3;
